<template>
  <div id="dashboard">
    <dash-header :pages="breadCrumbsPages" :dashboardTitle="dashboardTitle"></dash-header>
    <cousre-submitter v-if="userDetails.user_role === 'telas_course_submitters'"/>
    <telas-admin v-if="userDetails.user_role === 'telas_telas_administrator'"></telas-admin>
    <assessors
    v-if="userDetails.user_role === 'telas_interim_reviewers'
    || userDetails.user_role === 'telas_admin_reviewers'
    || userDetails.user_role === 'telas_certified_reviewers'"></assessors>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import cousreSubmitter from './Course-submitter.vue';
import assessors from './Assessors.vue';
import telasAdmin from './Telas-admin.vue';
import dashHeader from './Header.vue';

export default {
  data() {
    return {
      pageName: 'Dashboard',
      breadCrumbsPages: [
        {
          name: 'Home',
          route: '/',
        },
        {
          name: 'Dashboard',
          route: '/dashboard',
        },
      ],
      dashboardTitle: '',
    };
  },
  components: {
    cousreSubmitter,
    assessors,
    telasAdmin,
    dashHeader,
  },
  computed: {
    ...mapGetters('dashboard', {
      userDetails: 'getUserProfileDetails',
    }),
    ...mapState('user', {
      userID: state => state.userDetails.user_id,
    }),
    ...mapGetters('user', {
      userRole: 'getUserRole',
    }),
  },
  watch: {
    userDetails(val) {
      const userRoleStringArray = val.user_role.split('_');
      userRoleStringArray.shift();
      const userRole = userRoleStringArray.join(' ');
      this.dashboardTitle = `${userRole} Dashboard`;
    },
  },
  methods: {
    ...mapActions('dashboard', {
      getUserDetail: 'getUserDetail',
    }),
  },
  created() {
    this.getUserDetail({ user_id: this.userID });
  },
  mounted() {
  },
};
</script>
